import { render, staticRenderFns } from "./posPerformanceIndex.vue?vue&type=template&id=0d3015f2&"
import script from "./posPerformanceIndex.vue?vue&type=script&lang=js&"
export * from "./posPerformanceIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports